import React from 'react';
import { DataTableEntryProps } from './DataTableRow';

interface DataTableProps {
  headers: string[];
  children: React.ReactElement<DataTableEntryProps> | React.ReactElement<DataTableEntryProps>[];
}

const DataTable: React.FC<DataTableProps> = ({ headers, children }) => {
  return (
    <table className='bg-white m-8 font-raleway block p-4 overflow-scroll'>
      <thead>
        <tr className='font-bold text-left whitespace-nowrap'>
          {headers.map((header, i) => (
            <th
              key={i}
              className='border-black border-l-2 first:border-l-0 border-b-2 px-2 last:w-full'
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
};

export default DataTable;
